export default __webpack_public_path__ + "static/media/iusddown.210bec78.svg";